import React, { useEffect, useState } from 'react'
import { useLazyQuery, useMutation } from '@apollo/react-hooks'
import { AllGamesQuery } from '../../gql/queries'
import { DeleteGameMutation } from '../../gql/mutations'
import GameTable from './GameTable'
import { Row, Col } from 'reactstrap'
import { Link, useHistory } from 'react-router-dom'

const Games = () => {

  const history = useHistory()

  const [gameList, setGameList] = useState([])
  const [getGames, { loading, data, error }] = useLazyQuery(AllGamesQuery, 
    {fetchPolicy: 'no-cache'}) // defaultOptions of no-cache didn't seem to work

  const [deleteGame, deleteGameStatus] = useMutation(DeleteGameMutation)

 
  const onDeleteGame = (gameId: string) => {
    
      deleteGame({ variables: { id: gameId } })
   
  }




  useEffect(() => {
    getGames()
  }, [getGames])
  useEffect(() => {
    if (data && data.listGames) {

      const unsortedGame = data.listGames.items;

      const sortedGames = unsortedGame
      .sort((a : any ,b: any) => {
        return new Date(a.DateStart).getTime() - 
            new Date(b.DateStart).getTime()
    }).reverse();

      setGameList(data.listGames.items)
    }
  }, [data])

  useEffect(() => {
    const { called, loading, data, error } = deleteGameStatus
    if (called && !loading) {
      if (error) {
        // handle error
      }
      else if (data.deleteGame) {
         const { id } = data.deleteGame
         const newGameList = gameList.filter((g: any) => g.id !== id)
         console.log("GAME DELETED:" + id);
        // setGameList(newGameList)

        history.go(0) // yeah a hack

      }
    }

  }, [deleteGameStatus, gameList])


  return (
    <>
      <Row>
        <Col><h3>All Games</h3>
        <Link to="/">Home</Link>
        </Col>
      </Row>
      <Row>
        <Col>
          {loading ? ("Loading") :
            gameList.length > 0 ?
              <GameTable gameData={gameList} onDeleteGame={onDeleteGame} />
              : error ? error.message : "No games available"
          }
        </Col>
      </Row>
    </>
  )

}
export default Games
